module.exports = __webpack_public_path__ + "img/round-active.5162d7f8.svg";